<script setup lang="ts">
import UITextButtonInner from '@/components/ui/UITextButtonInner.vue'
import UIToolTip from '@/components/ui/UIToolTip.vue'
import { TButtonColor, TButtonIcon, TButtonVariant } from '@lifk/types'
import { computed } from 'vue'

// TODO: Rename to UIButton (separate small PR to reduce clutter)

const props = defineProps<{
  /** What icon should be displayed in the button? */
  icon?: TButtonIcon
  /** What text should be displayed in the button?<br/>(Can also be provided via the slot.) */
  text?: string
  /** What visual style should be used for the button? */
  variant?: TButtonVariant
  /** What color should be used for the button? */
  color?: TButtonColor
  /** Should the button's coloring be adjusted for use on a dark background? */
  inverse?: boolean
  /** Is the button currently selected? */
  selected?: boolean
  /** Should the icon be displayed on the right side of the text? */
  iconOnRight?: boolean
  /** Should a router link be used to render the button (allows users to interact with the button as a link)? */
  routerLink?: boolean
  /** What path should the user navigate to when the button is clicked (only used if routerLink is true)? */
  path?: string
  /** What target should be used for the router link (only used if routerLink is true)? */
  target?: string
  /** Is the button disabled? */
  disabled?: boolean
  /** What HTML control type should be applied to the button? */
  type?: 'submit' | 'button'
  /** Is the button exclusively an icon? (props.text will be moved into a tooltip) */
  iconOnly?: boolean
  /** Does the button have additional text to show in a tooltip? */
  tooltipText?: string
  /** What should the maximum width of the tooltip be? */
  tooltipMaxWidthPx?: number
}>()

const showTooltip = computed(() => {
  const isIconOnly = props.iconOnly && !!(props.tooltipText || props.text)
  const hasAdditionalTooltipText = !!props.tooltipText
  return isIconOnly || hasAdditionalTooltipText
})
</script>

<template>
  <div>
    <UIToolTip
      v-if="showTooltip"
      :text="tooltipText ?? text"
      direction="top"
      alignment="center"
      text-size="default"
      :max-width-px="tooltipMaxWidthPx"
    >
      <UITextButtonInner v-bind="props"><slot></slot></UITextButtonInner>
    </UIToolTip>
    <UITextButtonInner v-else v-bind="props"><slot></slot></UITextButtonInner>
  </div>
</template>
